var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1875 33.7188V46.2188C56.1875 47.0313 56.1563 47.8125 56.0625 48.5625C55.3438 57 50.375 61.1875 41.2188 61.1875H39.9688C39.1875 61.1875 38.4375 61.5625 37.9687 62.1875L34.2188 67.1875C32.5625 69.4063 29.875 69.4063 28.2187 67.1875L24.4687 62.1875C24.0625 61.6562 23.1563 61.1875 22.4688 61.1875H21.2188C11.25 61.1875 6.25 58.7188 6.25 46.2188V33.7188C6.25 24.5625 10.4688 19.5938 18.875 18.875C19.625 18.7813 20.4063 18.75 21.2188 18.75H41.2188C51.1875 18.75 56.1875 23.75 56.1875 33.7188Z",
    stroke: "#58BF52",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6875 21.2188V33.7188C68.6875 42.9063 64.4687 47.8438 56.0625 48.5625C56.1562 47.8125 56.1875 47.0313 56.1875 46.2188V33.7188C56.1875 23.75 51.1875 18.75 41.2187 18.75H21.2187C20.4062 18.75 19.625 18.7813 18.875 18.875C19.5937 10.4688 24.5625 6.25 33.7187 6.25H53.7187C63.6875 6.25 68.6875 11.25 68.6875 21.2188Z",
    stroke: "#58BF52",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1734 41.4062H42.2016",
    stroke: "#58BF52",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2359 41.4062H31.2641",
    stroke: "#58BF52",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2984 41.4062H20.3266",
    stroke: "#58BF52",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.0b744ce48c5063fd6f26c41ff6bba710.svg";
export { ForwardRef as ReactComponent };